<template>
  <section class="p-2">
    <v-card>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="2" lg="3" xs="12">
              <v-autocomplete
                class="rounded"
                v-model="selcted_partner"
                dense
                outlined
                placeholder="Partners"
                label="Partners"
                :items="partnerList"
                item-text="txt"
                item-value="val"
              ></v-autocomplete>
            </v-col>
            <v-btn
              depressed
              small
              @click="getpartnerBalance()"
              class="text-capitalize mt-1"
              color="primary"
              outlined
              >Get Results</v-btn
            >
          </v-row>
        </v-card>
      </v-card-text>
      <v-card-text>
        <v-btn
          depressed
          @click="downloadExcelsheet"
          class="ms-5"
          color="primary"
          small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-data-table :headers="headers" :items="balancedata" dense>
          <template v-slot:item.balance="{ item }">
            <h5 class="mb-0 primary--text">
              {{ item.balance ? item.balance : 0 }}
            </h5>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
import alerts from "@/mixins/alerts";
import setupService from "@/services/SetupService/setupService";
import commonService from "@/services/CommonService/commonService.js";
export default {
  mixins: [alerts],
  name: "API Balance",
  data() {
    return {
      headers: [
        { text: "Partner Name", value: "partner" },
        { text: "Balance", value: "balance" },
        { text: "currency", value: "currency_code" },
        { text: "ledger", value: "name" },
        { text: "ledger id", value: "ledger_id" },
      ],
      selcted_partner: null,
      balancedata: [],
      partnerList: [],
    };
  },

  mounted() {
    this.getAllPartnersdropdown();
  },
  methods: {
    async downloadExcelsheet() {
      if (this.balancedata) {
        this.exportToExcel(this.headers, this.balancedata, "Partner balance");
      }
    },
    async getAllPartnersdropdown() {
      try {
        const response = await commonService.getAllPartnersdropdown();
        if (response.data.status_code === 200) {
          this.partnerList = response.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
          console.log("partnerList", this.partnerList);
        }
      } catch (error) {
        this.partnerList = [];
        console.error(error);
      }
    },
    async getpartnerBalance() {
      try {
        const response = await setupService.getpartnerBalance({
          partner_id: this.selcted_partner,
        });
        if (response.data.status_code === 200) {
          this.balancedata = response.data.data;
        } else {
          this.balancedata = [];
          this.showAlertError(response.data.message);
        }
      } catch (e) {
        this.balancedata = [];
        this.showAlertError("Something went wrong please try again later.");
        console.error(e);
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}

.size {
  font-size: 80px;
}
.bord-color {
  border-radius: 10px;
}
</style>
